import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid, FGridMoneyCell } from '../grid';
import { BudgetConsolidationCostCenterRow } from './budgetconsolidation.models';

type Props = { rows: BudgetConsolidationCostCenterRow[]; loading?: boolean };

export default class BudgetConsolidationCostCenterGrid extends React.PureComponent<Props> {
  private columns: GridColDef[] = [
    { field: 'costcentercode', headerName: 'Cost Center', width: 140, cellClassName: 'master-cell' },
    { field: 'costcentername', headerName: 'Cost Center Name', flex: 1, minWidth: 280, cellClassName: 'master-cell' },
    { field: 'activitybudget', headerName: 'Activity', width: 150, renderCell: FGridMoneyCell, cellClassName: 'source-cell' },
    { field: 'directbudget', headerName: 'Direct', width: 150, renderCell: FGridMoneyCell, cellClassName: 'source-cell' },
    { field: 'investmentbudget', headerName: 'Investment', width: 150, renderCell: FGridMoneyCell, cellClassName: 'source-cell' },
    { field: 'totalbudget', headerName: 'Consolidated', width: 160, renderCell: FGridMoneyCell, cellClassName: 'computed-cell' },
    { field: 'approvedamount', headerName: 'Arbitrated', width: 160, renderCell: FGridMoneyCell, cellClassName: 'governed-cell' },
    { field: 'variance', headerName: 'Variance', width: 150, renderCell: FGridMoneyCell, cellClassName: 'computed-cell' },
  ];

  render() {
    return (
      <FDataGrid
        title="Consolidation by Cost Center"
        subtitle="Cross-department view for balancing demand and approved capacity."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={430}
        getRowId={(row: BudgetConsolidationCostCenterRow) => row.id}
        sx={{
          '& .master-cell': { bgcolor: 'info.lighter' },
          '& .source-cell': { bgcolor: 'action.hover' },
          '& .computed-cell': { bgcolor: 'success.lighter', fontWeight: 700 },
          '& .governed-cell': { bgcolor: 'warning.lighter', fontWeight: 700 },
        }}
      />
    );
  }
}
